/**
 * Single source of truth for (i) page help content.
 * Icons are MUI component names — resolved in PageHelpButton.jsx.
 */
export const PAGE_HELP = {
  LandingPage: {
    title: "landing_help_title",
    overview: "landing_overview",
    features: [
      { icon: "CardMembership", title: "membership_card", description: "landing_membership_card_desc" },
      { icon: "People", title: "landing_switch_user", description: "landing_family_switch_desc" },
      { icon: "Add", title: "add_family_member", description: "landing_add_family_desc" },
      { icon: "AccessTime", title: "coach_time_registration", description: "landing_coach_time_desc" },
      { icon: "Refresh", title: "refresh", description: "landing_refresh_desc" },
    ],
  },
  ProfilePage: {
    title: "profile_help_title",
    overview: "profile_overview",
    features: [
      { icon: "PhotoCamera", title: "profile_image", description: "profile_image_desc" },
      { icon: "Edit", title: "edit", description: "profile_save_desc" },
      { icon: "ExpandMore", title: "quick_actions", description: "profile_quick_actions_desc" },
      { icon: "People", title: "manage_family_members", description: "profile_manage_family_quick_desc" },
      { icon: "TrendingUp", title: "attendance", description: "profile_attendance_quick_desc" },
      { icon: "EmojiEvents", title: "achievements", description: "profile_achievements_quick_desc" },
      { icon: "SupervisorAccount", title: "my_mentor", description: "profile_my_mentor_quick_desc" },
      { icon: "Mood", title: "my_smilies", description: "profile_smilies_quick_desc" },
    ],
  },
  MessagePage: {
    title: "message_help_title",
    overview: "message_overview",
    features: [
      { icon: "Message", title: "messages", description: "message_conversations_desc" },
      { icon: "Send", title: "send_message", description: "message_send_desc" },
      { icon: "Reply", title: "reply", description: "message_reply_desc" },
      { icon: "Delete", title: "delete_messages", description: "message_delete_desc" },
      { icon: "FilterList", title: "filter", description: "message_filter_desc" },
    ],
  },
  NewsPage: {
    title: "news_help_title",
    overview: "news_overview",
    features: [
      { icon: "FilterList", title: "filter", description: "news_filter_desc" },
      { icon: "Article", title: "news_page_title", description: "news_list_desc" },
      { icon: "Article", title: "news_page_title", description: "news_read_desc" },
    ],
  },
  NewsDetail: {
    title: "news_detail_help_title",
    overview: "news_detail_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "news_detail_back_desc" },
      { icon: "Article", title: "news_page_title", description: "news_detail_read_desc" },
    ],
  },
  TrainingProgramPage: {
    title: "training_program_page_title",
    overview: "training_program_page_subtitle",
    features: [
      { icon: "FitnessCenter", title: "training_program", description: "training_program_page_subtitle" },
    ],
  },
  TrainingProgramDetail: {
    title: "training_program_page_title",
    overview: "training_program_page_subtitle",
    features: [
      { icon: "ArrowBack", title: "back", description: "news_detail_back_desc" },
    ],
  },
  TrainingProgramContentPage: {
    title: "training_program_admin_title",
    overview: "training_program_admin_description",
    features: [
      { icon: "Add", title: "training_program_new", description: "training_program_admin_description" },
    ],
  },
  ProfileBeltsPage: {
    title: "belts_help_title",
    overview: "belts_overview",
    features: [
      { icon: "MilitaryTech", title: "belt", description: "belts_view_desc" },
      { icon: "History", title: "promotions", description: "belts_history_desc" },
    ],
  },
  DigitalCardPage: {
    title: "digital_card_help_title",
    overview: "digital_card_overview",
    features: [
      { icon: "QrCode2", title: "qr_scanner", description: "digital_card_qr_desc" },
      { icon: "Person", title: "profile_image", description: "digital_card_profile_desc" },
      { icon: "Swipe", title: "landing_switch_user", description: "digital_card_swipe_desc" },
    ],
  },
  PosShopPage: {
    title: "pos_shop_help_title",
    overview: "pos_shop_overview",
    features: [
      { icon: "Storefront", title: "pos_shop_view_details", description: "pos_shop_browse_desc" },
      { icon: "ShoppingCart", title: "pos_shop_cart", description: "pos_shop_cart_desc" },
      { icon: "Payment", title: "pos_shop_continue_checkout", description: "pos_shop_checkout_desc" },
    ],
  },
  PosShopCheckoutPage: {
    title: "pos_shop_checkout_help_title",
    overview: "pos_shop_checkout_overview",
    features: [
      { icon: "ShoppingBag", title: "pos_shop_order_summary", description: "pos_shop_checkout_summary_desc" },
      { icon: "CreditCard", title: "pos_shop_pay_card", description: "pos_shop_checkout_stripe_desc" },
    ],
  },
  PosShopKioskPage: {
    title: "pos_kiosk_help_title",
    overview: "pos_kiosk_overview",
    features: [
      { icon: "Storefront", title: "pos_tab_products", description: "pos_kiosk_products_desc" },
      { icon: "PersonSearch", title: "pos_kiosk_customer_title", description: "pos_kiosk_customer_desc" },
      { icon: "CreditCard", title: "pos_kiosk_charge_customer", description: "pos_kiosk_charge_desc" },
      { icon: "Fullscreen", title: "fullscreen", description: "pos_kiosk_fullscreen_desc" },
    ],
  },
  ProfileColorPromotionPage: {
    title: "color_promotion_help_title",
    overview: "color_promotion_overview",
    features: [
      { icon: "Palette", title: "color_promotion", description: "color_promotion_submit_desc" },
      { icon: "Check", title: "submit", description: "color_promotion_submit_desc" },
    ],
  },
  ParentColorPromotion: {
    title: "color_promotion_help_title",
    overview: "color_promotion_parent_overview",
    features: [
      { icon: "Palette", title: "color_promotion", description: "color_promotion_parent_desc" },
      { icon: "Check", title: "submit", description: "color_promotion_submit_desc" },
    ],
  },
  SchedulePage: {
    title: "schedule_help_title",
    overview: "schedule_overview",
    features: [
      { icon: "Schedule", title: "schedule_title", description: "schedule_view_desc" },
      { icon: "Add", title: "add", description: "schedule_add_desc" },
      { icon: "Edit", title: "edit", description: "schedule_edit_desc" },
      { icon: "FilterList", title: "filter", description: "schedule_filter_desc" },
    ],
  },
  InstructorSchedulePage: {
    title: "instructor_schedule_help_title",
    overview: "instructor_schedule_overview",
    features: [
      { icon: "EventNote", title: "instructor_schedule_title", description: "instructor_schedule_view_desc" },
      { icon: "Edit", title: "edit", description: "instructor_schedule_edit_desc" },
      { icon: "Add", title: "add", description: "instructor_schedule_add_desc" },
    ],
  },
  InstructorAvailabilityPage: {
    title: "instructor_availability_help_title",
    overview: "instructor_availability_overview",
    features: [
      { icon: "DateRange", title: "from_date", description: "instructor_availability_date_filter_desc" },
      { icon: "EventAvailable", title: "instructor_availability_title", description: "instructor_availability_admin_view_desc" },
      { icon: "CheckCircle", title: "instructor_availability_register", description: "instructor_availability_register_desc" },
      { icon: "Send", title: "instructor_availability_send_request", description: "instructor_availability_send_request_desc" },
    ],
  },
  AchievementsPage: {
    title: "achievements_help_title",
    overview: "achievements_overview",
    features: [
      { icon: "EmojiEvents", title: "achievements", description: "achievements_view_desc" },
    ],
  },
  MyMentorPage: {
    title: "my_mentor_help_title",
    overview: "my_mentor_overview",
    features: [
      { icon: "SupervisorAccount", title: "mentors", description: "my_mentor_info_desc" },
      { icon: "Message", title: "messages", description: "my_mentor_contact_desc" },
    ],
  },
  MySmiliesPage: {
    title: "my_smilies_help_title",
    overview: "my_smilies_overview",
    features: [
      { icon: "SentimentSatisfied", title: "green_message", description: "green_message_description" },
      { icon: "SentimentDissatisfied", title: "red_message", description: "red_message_description" },
      { icon: "Send", title: "send_message_to_mentor", description: "my_smilies_contact_desc" },
    ],
  },
  ProfileManageFamily: {
    title: "manage_family_help_title",
    overview: "manage_family_overview",
    features: [
      { icon: "People", title: "manage_family_members", description: "manage_family_switch_desc" },
      { icon: "PersonAdd", title: "add_users", description: "manage_family_add_desc" },
      { icon: "Palette", title: "color_promotion", description: "manage_family_color_promotion_desc" },
    ],
  },
  ProfileAddChildPage: {
    title: "add_child_help_title",
    overview: "add_child_overview",
    features: [
      { icon: "PersonAdd", title: "add_users", description: "add_child_create_desc" },
      { icon: "Search", title: "search", description: "add_child_find_desc" },
    ],
  },
  ProfileAttendancePage: {
    title: "attendance_help_title",
    overview: "attendance_overview",
    features: [
      { icon: "TrendingUp", title: "attendance", description: "attendance_view_desc" },
      { icon: "CalendarMonth", title: "attendance", description: "attendance_records_desc" },
      { icon: "FilterList", title: "filter", description: "attendance_filter_desc" },
    ],
  },
  MembershipPage: {
    title: "membership_help_title",
    overview: "membership_overview",
    features: [
      { icon: "CardMembership", title: "membership", description: "membership_status_desc" },
      { icon: "Event", title: "expiration_date", description: "membership_details_desc" },
    ],
  },
  MembersGroupAddUsersPage: {
    title: "members_group_add_help_title",
    overview: "members_group_add_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "members_group_add_back_desc" },
      { icon: "Search", title: "search", description: "members_group_add_search_desc" },
      { icon: "PersonAdd", title: "add_users", description: "members_group_add_add_desc" },
      { icon: "Remove", title: "remove", description: "members_group_add_remove_desc" },
    ],
  },
  PendingPromotionPage: {
    title: "pending_promotion_help_title",
    overview: "pending_promotion_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "pending_promotion_back_desc" },
      { icon: "CheckBox", title: "select", description: "pending_promotion_checkbox_desc" },
      { icon: "CheckCircle", title: "approve", description: "pending_promotion_approve_desc" },
      { icon: "Person", title: "profile_image", description: "pending_promotion_image_desc" },
    ],
  },
  PendingColorPromotionPage: {
    title: "pending_color_help_title",
    overview: "pending_color_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "pending_color_back_desc" },
      { icon: "CheckBox", title: "select", description: "pending_color_checkbox_desc" },
      { icon: "CheckCircle", title: "approve", description: "pending_color_approve_desc" },
      { icon: "Person", title: "profile_image", description: "pending_color_image_desc" },
    ],
  },
  MentorListPage: {
    title: "mentor_list_help_title",
    overview: "mentor_list_overview",
    importantNote: "promotion_rule",
    features: [
      { icon: "special:checkbox", title: "send_message_to_selected", description: "mentor_list_select_students" },
      { icon: "special:avatar", title: "image", description: "mentor_list_profile_photo" },
      { icon: "special:green_smiley", title: "green_message", description: "green_message_description" },
      { icon: "special:red_smiley", title: "red_message", description: "red_message_description" },
      { icon: "MilitaryTech", title: "create_promotion", description: "mentor_list_belt_promotion" },
      { icon: "Send", title: "send_message", description: "mentor_list_send_message" },
    ],
  },
  MentorManagerPage: {
    title: "mentor_manager_help_title",
    overview: "mentor_manager_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "mentor_manager_back_desc" },
      { icon: "PersonAdd", title: "add_mentor", description: "mentor_manager_add_mentor_desc" },
      { icon: "GroupAdd", title: "add_users", description: "mentor_manager_add_students_desc" },
      { icon: "Remove", title: "remove", description: "mentor_manager_remove_desc" },
      { icon: "Person", title: "image", description: "mentor_manager_image_desc" },
    ],
  },
  BeltPromotionPage: {
    title: "belt_promotion_help_title",
    overview: "belt_promotion_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "belt_promotion_back_desc" },
      { icon: "Person", title: "select_user", description: "belt_promotion_select_desc" },
      { icon: "Groups", title: "select_group", description: "belt_promotion_group_desc" },
      { icon: "GroupAdd", title: "promotion_by_group", description: "belt_promotion_by_group_desc" },
      { icon: "CheckCircle", title: "approve", description: "belt_promotion_approve_desc" },
    ],
  },
  PromotionByGroup: {
    title: "promotion_by_group_help_title",
    overview: "promotion_by_group_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "promotion_by_group_back_desc" },
      { icon: "Groups", title: "select_group", description: "promotion_by_group_select_desc" },
      { icon: "MilitaryTech", title: "belt", description: "promotion_by_group_belt_desc" },
      { icon: "CheckCircle", title: "approve", description: "promotion_by_group_approve_desc" },
    ],
  },
  BeltAdminPage: {
    title: "belt_admin_help_title",
    overview: "belt_admin_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "belt_admin_back_desc" },
      { icon: "Groups", title: "select_group", description: "belt_admin_select_group_desc" },
      { icon: "Edit", title: "edit", description: "belt_admin_edit_desc" },
      { icon: "Delete", title: "delete", description: "belt_admin_delete_desc" },
    ],
  },
  ClubSettingsPage: {
    title: "club_settings_help_title",
    overview: "club_settings_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "club_settings_back_desc" },
      { icon: "Business", title: "name", description: "club_settings_name_desc" },
      { icon: "Image", title: "club", description: "club_settings_logo_desc" },
      { icon: "Category", title: "finance_group_list_gt", description: "club_settings_group_types_desc" },
      { icon: "DateRange", title: "finance_billing_period", description: "club_settings_periods_desc" },
    ],
  },
  UserAdminPage: {
    title: "user_admin_help_title",
    overview: "user_admin_overview",
    features: [
      { icon: "Search", title: "search", description: "user_admin_search_filter" },
      { icon: "Delete", title: "delete_users", description: "user_admin_select_delete" },
      { icon: "Person", title: "user_admin_image", description: "user_admin_image" },
      { icon: "Edit", title: "edit", description: "user_admin_edit" },
      { icon: "Groups", title: "groups", description: "user_admin_groups" },
      { icon: "Settings", title: "permissions", description: "user_admin_settings" },
      { icon: "LockReset", title: "admin_send_temp_password", description: "admin_send_temp_password_desc" },
      { icon: "PictureAsPdf", title: "user_admin_pdf", description: "user_admin_pdf" },
    ],
  },
  ClubAttendanceStats: {
    title: "club_attendance_help_title",
    overview: "club_attendance_overview",
    features: [
      { icon: "ArrowBack", title: "back", description: "club_attendance_back_desc" },
      { icon: "BarChart", title: "attendance_stats", description: "club_attendance_stats_desc" },
      { icon: "Groups", title: "groups", description: "club_attendance_groups_desc" },
      { icon: "DateRange", title: "from_date", description: "club_attendance_date_desc" },
    ],
  },
  QRScannerPage: {
    title: "qr_scanner_help_title",
    overview: "qr_scanner_overview",
    features: [
      { icon: "QrCode2", title: "qr_scanner", description: "qr_scanner_scan_instruction" },
      { icon: "Fullscreen", title: "fullscreen", description: "qr_scanner_camera_desc" },
      { icon: "Keyboard", title: "manual_student_id", description: "qr_scanner_manual_instruction" },
      { icon: "CardMembership", title: "membership_card", description: "qr_scanner_find_id_desc" },
    ],
  },
  QRResultPage: {
    title: "qr_result_help_title",
    overview: "qr_result_overview",
    features: [
      { icon: "Person", title: "profile", description: "qr_result_profile_desc" },
      { icon: "CheckCircle", title: "attendance", description: "qr_result_attendance_desc" },
      { icon: "QrCodeScanner", title: "qr_scanner", description: "qr_result_back_desc" },
    ],
  },
  ContentPage: {
    title: "new_content_help_title",
    overview: "new_content_overview",
    features: [
      { icon: "Add", title: "add", description: "new_content_create_desc" },
      { icon: "FilterList", title: "filter", description: "new_content_filter_desc" },
      { icon: "Search", title: "search", description: "new_content_search_desc" },
      { icon: "Visibility", title: "preview", description: "new_content_preview_desc" },
      { icon: "Edit", title: "edit", description: "new_content_edit_desc" },
      { icon: "Delete", title: "delete", description: "new_content_delete_desc" },
    ],
  },
  ApprovalCenterPage: {
    title: "approval_center_help_title",
    overview: "approval_center_overview",
    features: [
      { icon: "PersonAdd", title: "unapproved_accounts", description: "approval_center_unreviewed_desc" },
      { icon: "MilitaryTech", title: "pending_belt_promotions", description: "approval_center_tabs_desc" },
      { icon: "Palette", title: "pending_color_promotions", description: "approval_center_color_promotions_desc" },
      { icon: "FamilyRestroom", title: "parent_connections_pending_approval", description: "approval_center_parent_desc" },
      { icon: "Schedule", title: "instructor_attendance_pending_approval", description: "approval_center_instructor_attendance_desc" },
      { icon: "Inbox", title: "approval_center_anmalningar_title", description: "approval_center_anmalningar_desc" },
      { icon: "CheckCircle", title: "approve", description: "approval_center_approve_desc" },
    ],
  },
  SettingsPage: {
    title: "settings_help_title",
    overview: "settings_overview",
    importantNote: "settings_help_badge_note",
    features: [],
  },
  FinancePage: {
    title: "finance_help_title",
    overview: "finance_overview",
    importantNote: "finance_billing_period_desc",
    features: [
      { icon: "AttachMoney", title: "finance_members", description: "finance_tab_members_desc" },
      { icon: "ReceiptLong", title: "finance_group_costs", description: "finance_tab_group_costs_desc" },
      { icon: "Campaign", title: "finance_notices_tab", description: "finance_tab_notices_desc" },
      { icon: "PersonOff", title: "finance_opt_outs_tab", description: "finance_tab_opt_outs_desc" },
      { icon: "Tune", title: "finance_payment_settings", description: "finance_tab_payment_settings_desc" },
    ],
  },
  TrainingGroupsPage: {
    title: "training_groups_help_title",
    overview: "training_groups_overview",
    features: [
      { icon: "Groups", title: "group_mailing_tab_groups", description: "training_groups_tab_groups_desc" },
      { icon: "FilterList", title: "finance_group_list_weekday", description: "finance_group_list_filter_desc" },
      { icon: "PersonAdd", title: "finance_group_list_help_add", description: "finance_group_list_help_add_desc" },
      { icon: "Edit", title: "edit", description: "finance_group_list_edit_desc" },
    ],
  },
  GroupMailingsPage: {
    title: "group_mailings_help_title",
    overview: "group_mailings_overview",
    features: [
      { icon: "MailOutline", title: "group_mailing_tab_mailings", description: "training_groups_tab_mailings_desc" },
      { icon: "History", title: "group_mailing_tab_history", description: "group_mailing_history_intro" },
      { icon: "People", title: "group_mailing_recipients_title", description: "group_mailing_help_recipients_desc" },
      { icon: "Send", title: "group_mailing_send", description: "group_mailing_help_send_desc" },
    ],
  },
  LokStodPage: {
    title: "lok_help_title",
    overview: "lok_help_overview",
    features: [
      { icon: "Dashboard", title: "lok_tab_overview", description: "lok_status_card_title" },
      { icon: "FactCheck", title: "lok_run_validation", description: "lok_validating" },
      { icon: "Sync", title: "lok_sync_with_rf", description: "lok_sync_progress_title" },
      { icon: "ListAlt", title: "lok_tab_activities", description: "lok_review_activities" },
      { icon: "History", title: "lok_tab_sync_history", description: "lok_no_sync_history" },
    ],
  },
  PosAdminPage: {
    title: "pos_admin_help_title",
    overview: "pos_admin_overview",
    importantNote: "pos_admin_kiosk_open_desc",
    features: [
      { icon: "Settings", title: "pos_tab_settings", description: "pos_admin_settings_desc" },
      { icon: "Inventory", title: "pos_tab_products", description: "pos_admin_products_desc" },
      { icon: "Receipt", title: "pos_tab_orders", description: "pos_admin_orders_desc" },
      { icon: "BarChart", title: "pos_tab_stats", description: "pos_admin_stats_desc" },
    ],
  },
  TimerPage: {
    title: "timer_help_title",
    overview: "timer_overview",
    features: [
      { icon: "Timer", title: "timer_help_title", description: "timer_rounds_desc" },
      { icon: "Timer", title: "rest", description: "timer_rest_desc" },
      { icon: "PlayArrow", title: "start", description: "timer_start_desc" },
      { icon: "Fullscreen", title: "fullscreen", description: "timer_fullscreen_desc" },
    ],
  },
  TimeRegistrationPage: {
    title: "time_registration_help_title",
    overview: "time_registration_overview",
    features: [
      { icon: "AccessTime", title: "coach_time_registration", description: "time_registration_register_desc" },
      { icon: "People", title: "students", description: "time_registration_students_desc" },
    ],
  },
  InvoicePage: {
    title: "invoice_help_title",
    overview: "invoice_overview",
    features: [
      { icon: "CreditCard", title: "invoice_pay_now", description: "invoice_pay_desc" },
      { icon: "ReceiptLong", title: "invoice_opt_out_section_title", description: "invoice_opt_out_desc" },
      { icon: "Schedule", title: "invoice_expired", description: "invoice_expired_desc" },
    ],
  },
  FinancePaymentSuccess: {
    title: "finance_payment_success_help_title",
    overview: "finance_payment_thank_you",
    features: [
      { icon: "CheckCircle", title: "finance_payment_received", description: "finance_payment_success_desc" },
      { icon: "Home", title: "back_to_app", description: "finance_payment_success_back_desc" },
    ],
  },
  FinancePaymentCancel: {
    title: "finance_payment_cancel_help_title",
    overview: "finance_payment_no_charge",
    features: [
      { icon: "Cancel", title: "finance_payment_cancelled", description: "finance_payment_cancel_desc" },
      { icon: "Home", title: "back_to_app", description: "finance_payment_cancel_back_desc" },
    ],
  },
  PosShopPaymentSuccess: {
    title: "pos_shop_payment_success_help_title",
    overview: "pos_shop_payment_success_body",
    features: [
      { icon: "CheckCircle", title: "pos_shop_payment_success_title", description: "pos_shop_payment_success_desc" },
      { icon: "Home", title: "back_to_app", description: "pos_shop_payment_success_back_desc" },
    ],
  },
  PosShopPaymentCancel: {
    title: "pos_shop_payment_cancel_help_title",
    overview: "pos_shop_payment_cancel_body",
    features: [
      { icon: "Cancel", title: "pos_shop_payment_cancel_title", description: "pos_shop_payment_cancel_desc" },
      { icon: "Storefront", title: "pos_shop_title", description: "pos_shop_payment_cancel_back_desc" },
    ],
  },
  LoginPage: {
    title: "login_help_title",
    overview: "login_help_overview",
    features: [
      { icon: "Login", title: "login", description: "login_help_signin_desc" },
      { icon: "PersonAdd", title: "login_no_account", description: "login_help_signup_desc" },
      { icon: "LockReset", title: "password_reset", description: "login_help_reset_desc" },
    ],
  },
  SignupPage: {
    title: "signup_help_title",
    overview: "signup_before_register",
    features: [
      { icon: "Person", title: "signup_i_am_student", description: "signup_help_student_desc" },
      { icon: "FamilyRestroom", title: "signup_i_am_parent", description: "signup_help_parent_desc" },
      { icon: "PhotoCamera", title: "signup_upload_picture", description: "signup_upload_picture_details" },
    ],
  },
  PasswordResetRequestPage: {
    title: "password_reset_help_title",
    overview: "password_reset_help_overview",
    features: [
      { icon: "Email", title: "email", description: "password_reset_help_email_desc" },
      { icon: "Login", title: "login", description: "password_reset_help_login_desc" },
    ],
  },
  PasswordResetPage: {
    title: "password_reset_new_help_title",
    overview: "password_reset_new_help_overview",
    features: [
      { icon: "Lock", title: "password", description: "password_reset_new_help_password_desc" },
      { icon: "Login", title: "login", description: "password_reset_help_login_desc" },
    ],
  },
  DocumentationPage: {
    title: "documentation_help_title",
    overview: "documentation_overview",
    features: [
      { icon: "MenuBook", title: "documentation_title", description: "documentation_browse_desc" },
      { icon: "Search", title: "search", description: "documentation_search_desc" },
      { icon: "OpenInNew", title: "documentation_open_page", description: "documentation_open_page_desc" },
    ],
  },
};
